import styled from "styled-components";

export const HierarchicalMultiSelectWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const SelectButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100% !important;
  height: 56px !important;
  padding: 20px 12px !important;
  background-color: #fff !important;
  border: thin solid #99a6b9 !important;
  border-radius: 8px !important;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  color: #253858 !important;
  opacity: 1 !important;
  transition: border-color 0.3s ease-in-out !important;
  overflow: hidden;

  svg {
    width: 20px;
    height: 20px;
    transition: transform 0.2s ease;
  }

  &.disabled {
    background-color: #e7e9ed !important;
    cursor: not-allowed;
    opacity: 0.7 !important;
  }
`;

export const SelectedText = styled.span`
  color: #000000d9;
  font-size: 14px;
  line-height: 1.5715;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const DropdownContainer = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  margin-top: 4px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 2;
`;

export const SelectPanel = styled.div`
  .theme-form-input-container {
    width: 100%;
  }
`;

export const SearchBar = styled.div`
  margin-bottom: 8px;
`;

export const BackButton = styled.button`
  width: 100%;
  padding: 16px 24px;
  background: none;
  border: none;
  border-bottom: 1px solid #e7e9ed;
  text-align: left;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 7px;
  span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex-shrink: 1;
  }
  .theme-multilevel-arrow {
    transform: rotate(180deg);
    width: 24px;
    height: 24px;
    border-radius: 100%;
  }
`;

export const PanelList = styled.div`
  max-height: 300px;
  overflow-y: auto;
`;

export const PanelItem = styled.div`
  padding: 8px 12px;
  cursor: pointer;
  transition: background-color 0.3s;

  &:hover {
    background-color: #f5f5f5;
  }
`;

export const ItemLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  flex: 1;
  min-width: 0;
  font-size: 14px;
  color: #333333;
  user-select: none;
  overflow: hidden;

  span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex-shrink: 1;
  }

  input[type="checkbox"] {
    width: 18px;
    height: 18px;
    margin: 0;
    cursor: pointer;
    accent-color: #3548c9;
    border: 2px solid #bdbdbd;
    border-radius: 2px;
    transition: all 0.2s ease;
    flex-shrink: 0;

    &:hover {
      border-color: #3548c9;
    }

    &:checked {
      background-color: #3548c9;
      border-color: #3548c9;
    }
  }
`;

export const CheckboxIconWrapper = styled.div<{ checked: boolean }>`
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid ${({ checked }) => (checked ? "#1890ff" : "#d9d9d9")};
  border-radius: 2px;
  background-color: ${({ checked }) => (checked ? "#1890ff" : "#fff")};
  transition: all 0.2s ease;

  svg {
    width: 16px;
    height: 16px;
    fill: #fff;
    visibility: ${({ checked }) => (checked ? "visible" : "hidden")};
  }
`;

export const ItemArrow = styled.span`
  color: #bfbfbf;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const NoResults = styled.div`
  padding: 8px 12px;
  color: #00000040;
  text-align: center;
`;

export const CheckIcon = styled.div<{ checked: boolean }>`
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(props) => (props.checked ? "#3548C9" : "transparent")};
  border: 1px solid #d9d9d9;
  border-radius: 2px;

  svg {
    width: 16px;
    height: 16px;
  }
`;

export const ResetButton = styled.button`
  width: 100%;
  padding: 8px 12px;
  background: none;
  border: none;
  text-align: left;
  color: #ff4d4f;
  font-size: 14px;
  cursor: pointer;
  transition: color 0.3s ease;

  &:hover {
    color: #ff7875;
  }
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  flex-shrink: 0;

  svg {
    width: 24px;
    height: 24px;
    transition: transform 0.2s ease;
  }
`;
